module.exports = __webpack_public_path__ + "img/a70a3e7b02f843a0810f99f7c6ceb2ed.1484fc2e.jpg";